import React from "react";
import Error from "../ui/Error";
import Loading from "../ui/Loading";
import PlaylistVideo from "./PlaylistVideo";

export default function Playlist({ videos, isLoading, error }) {
  // deciding what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && error) {
    content = <Error message={error} />;
  } else if (!isLoading && !error && videos.length === 0) {
    content = <div>No videos found!</div>;
  } else if (!isLoading && !error && videos.length > 0) {
    content = videos.map((video) => {
      return <PlaylistVideo key={video.id} video={video} />;
    });
  }

  return (
    <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
      {content}
    </div>
  );
}
